import { render, staticRenderFns } from "./lottery-config.vue?vue&type=template&id=1aff742b&scoped=true&"
import script from "./lottery-config.vue?vue&type=script&lang=js&"
export * from "./lottery-config.vue?vue&type=script&lang=js&"
import style0 from "./lottery-config.vue?vue&type=style&index=0&id=1aff742b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff742b",
  null
  
)

export default component.exports